import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Services } from "../../../utils/apis/service/Service";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading";
import Free_Consultation from "../../home/free-consultation/Free_Consultation";

// Stylesheets
import "./Service_page.css";

const Service_page = () => {
  const navigate = useNavigate();

  const handleServiceClick = (id) => {
    navigate(`/services/${id}`);
  };

  const { IMG_URL } = useContext(Context);
  const [service, setService] = useState([]);

  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const getService = async () => {
    const res = await Services();

    if (res?.success) {
      setService(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getService();
  }, []);

  return (
    <section className="Service_page_wrapper">
      {/* Structural Atmospheric Glow Shapes */}
      <div className="service_bg_glow_1"></div>
      <div className="service_bg_glow_2"></div>

      <div className="container position-relative">
        <Common_heading
          title="Our Enterprise IT Services"
          subtitle="Deploy scalable infrastructure, automated workflows, and robust security protocols engineered for modern business."
        />

        <div className="services_grid_layout">
          <div className="row">
            {service.map((item, index) => (
              <div
                className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-5"
                key={item.id || index}
              >
                <div
                  className="premium_service_card"
                  onClick={() => handleServiceClick(item.id)}
                >
                  <div className="service_image_frame">
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt={item.name}
                      className="tech_card_img"
                    />

                    <div className="image_gradient_shroud"></div>
                  </div>

                  <div className="service_card_body">
                    <h3 className="service_headline_title">
                      {item.name}
                      <span className="title_accent_bar"></span>
                    </h3>

                    <div className="service_synopsis">
                      {htmlToReactParser.parse(item.description)}
                    </div>

                    <div className="service_target_meta">
                      <span className="meta_label">
                        Deployment Target:
                      </span>

                      <div className="meta_pill_container">
                        {item?.ServiceBestFors?.map((meta, idx) => (
                          <span className="meta_pill" key={idx}>
                            {meta?.BestFor?.name}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Free Consultation Section */}
          <div className="consultation_divider_break">
            <Free_Consultation />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service_page;